import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';

import createRootReducer from 'state/reducers';
import rootSaga from 'store/rootSaga';

export const history = createBrowserHistory({
  basename: process.env.NODE_ENV === 'test' ? '' : '/ClientApp',
});

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: createRootReducer(history),
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    routerMiddleware(history),
    sagaMiddleware,
  ],
});

sagaMiddleware.run(rootSaga);

// hot module replacement for reducers
if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('state/reducers', () =>
    store.replaceReducer(createRootReducer(history))
  );
}

export type Store = typeof store;
export type AppDispatch = typeof store.dispatch;

export default store;
